import React from 'react';
import { FiArrowRight } from 'react-icons/fi';

import useTranslate from '@src/i18n/useTranslate';
import Button, { ButtonProps } from '@src/components/ui2/Button';
import usePhoneVerification from '@src/hooks/usePhoneVerification';

export const SubmitButton = ({ children, type = 'submit', fullWidth = true, ...rest }: ButtonProps) => {
  const { i18n } = useTranslate();
  const { loading } = usePhoneVerification();

  return (
    <Button {...rest} loading={loading || rest.loading} type={type} fullWidth={fullWidth}>
      {children ?? (
        <>
          {i18n('phone_verification_submit_button')}
          <FiArrowRight size={20} style={{ marginLeft: '4px' }} />
        </>
      )}
    </Button>
  );
};

export default SubmitButton;
